import styled from 'styled-components';

export const HomeCoverWrapper = styled.div`
    position: relative;
    padding-bottom:160px;
`;

export const HotelLogoWrapper = styled.div`
    width:250px;
    height:auto;
    position: absolute;
    margin-left:auto;
    margin-right:auto;
    left:0;
    right:0;
    bottom:0;
    display:flex;
    flex-direction:column;
    gap:10px;
    align-items:center;
    justify-content:center;
`;

export const HotelLogoContainer = styled.div`
    width:120px;
    height:120px;
    overflow:hidden;
    display:flex;
    align-items:center;
    justify-content:center;
    border-radius:100%;
    border:solid #F4F4F5;
    padding: 5px;
    position: relative;
`;

export const LogoText = styled.p`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 5px;
    font-size: 12px;
    color: #52525B;
    background: rgba(255, 255, 255, 0.9);
`;

export const HotelName = styled.h3`
    font-size:18px;
    font-weight:500;
`;

export const Addres = styled.p` 
 font-size:12px;
 line-height:1.7;
 color: #52525B;
 text-align:center;
`;
